import CategorySimpleView from './CategorySimpleView'

export default CategorySimpleView
